import { render, staticRenderFns } from "./PersonalInformationRequestForm.vue?vue&type=template&id=1444d450&scoped=true"
import script from "./PersonalInformationRequestForm.vue?vue&type=script&lang=js"
export * from "./PersonalInformationRequestForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalInformationRequestForm.vue?vue&type=style&index=0&id=1444d450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1444d450",
  null
  
)

export default component.exports